module.exports = __webpack_public_path__ + "static/img/footer_h5icon_01_zh.b610b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_h5icon_01_zh.png
// module id = uazx
// module chunks = 34